// extracted by mini-css-extract-plugin
export default {"container":"ip5WTJ","select":"VHfV65","share-buttons":"_n5JOe","shareButtons":"_n5JOe","icon":"gr2cNO"};